<template>
  <div class="product-tags-box">
    <div class="trigger-box">
      <span class="selectNumBox">
        已选择<span class="num">{{ tagIds.length }}</span
        >个
      </span>
      <bi-button type="blueText" @click="handleClick">选择标签</bi-button>
    </div>

    <product-tags-dialog
      :isMultiple="isMultiple"
      :nowShopList="nowShopList"
      :showModal.sync="dialogVisible"
      :value="tagIds"
      :isMultiSelect="isMultiSelect"
      :tagClassifyType="tagClassifyType"
      :tagClassifyList="tagClassifyList"
      @confirm="handleConfirm"
      :platformCompanySellerId="platformCompanySellerId"
      :showTagRelation="showTagRelation"
    ></product-tags-dialog>
  </div>
</template>

<script>
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import ProductTagsDialog from "./productTagsDialog.vue";

export default {
  name: "ProductTagsCom",
  components: {
    ProductTagsDialog,
  },
  props: {
    value: {
      type: [String, Array],
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择标签",
    },
    platformCompanySellerId: {
      type: [String, Array],
      default: "",
    },
    // 是否多店铺
    isMultiple: {
      type: Boolean,
      default: false,
    },
    nowShopList: {
      type: Array,
      default: () => [],
    },
    // 是否显示标签关系（并列/级联）
    showTagRelation: {
      type: Boolean,
      default: false,
    },
    // 商品标签分类类型
    tagClassifyType: {
      type: Number,
      default: 0,
    },
    // 商品标签分类列表
    tagClassifyList: {
      type: Array,
      default: () => [],
    },
    tagClassifyNames: {
      type: Array,
      default: () => [],
    },
    // 是否多选（false 时为单选模式）
    isMultiSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      internalValue: "", // 内部存储的值
      tagIds: [], // 内部存储选中的ID数组
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (!isEqual(newVal, this.internalValue)) {
          this.internalValue = cloneDeep(newVal);
          // 自动判断传入类型，转换为内部需要的数组格式
          if (Array.isArray(newVal)) {
            this.tagIds = cloneDeep(newVal);
          } else if (typeof newVal === "string") {
            this.tagIds = newVal ? newVal.split(",").map(Number) : [];
          } else {
            this.tagIds = [];
          }

          if (!this.isMultiSelect && this.tagIds.length > 1) {
            this.tagIds = this.tagIds.slice(0, 1);
          }

          console.log(this.tagIds,'1234');
        }
      },
      immediate: true,
      deep: true,
    },
    internalValue: {
      handler(newVal) {
        this.$emit("input", cloneDeep(newVal));
      },
      deep: true,
    },
    // platformCompanySellerId: {
    //   handler(newVal) {
    //     console.log(newVal, 'newValppp');
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    reset() {
      this.tagIds = [];
      this.internalValue = Array.isArray(this.internalValue) ? [] : "";
    },
    handleClick() {
      this.dialogVisible = true;
      this.$emit("click");
    },
    handleConfirm(selectedIds, groupSelected, cascadeList, cascadeNames) {
      this.tagIds = cloneDeep(selectedIds);
      this.internalValue = Array.isArray(this.value)
        ? cloneDeep(this.tagIds)
        : this.tagIds.join(",");
      this.$emit("change", cloneDeep(this.internalValue));
      this.$nextTick(() => {
        this.$emit('update:tagClassifyType', groupSelected);
        this.$emit('update:tagClassifyList', cloneDeep(cascadeList));
        this.$emit('update:tagClassifyNames', cloneDeep(cascadeNames));
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.product-tags-box {
  width: 300px;
  .trigger-box {
    height: 32px;
    line-height: 32px;
    padding: 0 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    width: 300px;
    background: #fff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdee1;

    &:hover,
    &.is-active {
      border-color: #3159ff;
    }
    .trigger-text {
      font-size: 14px;
      color: #606266;
      width: 234px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .selectNumBox {
      background: #f5f5f5;
      border-radius: 2px 2px 2px 2px;
      height: 24px;
      line-height: 24px;
      padding: 0 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 8px;
      .num {
        color: #ff7f23;
        padding: 0 2px;
      }
    }
  }
}
</style>
